<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
      <el-tab-pane label="注册患儿" name="first">
        <keep-alive>
        <ChildTable v-if="activeName=='first'" pageType="first" :isTimeout="isTimeout" ref="ChildTable1"></ChildTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="超期患儿" name="second">
        <keep-alive>
        <ChildTable v-if="activeName=='second'"  pageType="second" :isTimeout="isTimeout" ref="ChildTable2"></ChildTable>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import ChildTable from "./ChildTable";

  export default {
    data() {
      return {
        newDialog: true,
        activeName: 'first',
        openScreen1: false,
        openScreen2: false,
        value1: '',
        value2: '',
        tableData: [],
        helpStatus:[],
        isTimeout:0,
      }
    },
    watch: {
      '$route.query': {
        deep: true,
        handler () {
          if(this.$route.query.tap) {
            this.activeName = this.$route.query.tap
            if(this.activeName == 'second'){
              this.isTimeout = 1
              this.$refs.ChildTable2.queryList();
            }
          } else {
            this.isTimeout = 0
            this.activeName = 'first'
            this.$forceUpdate()
            this.$refs.ChildTable1.queryList();
          }
        }
      }
    },
    created() {
      if(this.$route.query.tap){
        this.activeName = this.$route.query.tap
        if(this.activeName=='second'){
          this.isTimeout =1
        }
      }
    },
    methods: {
      handleClick(tab, event) {
        if(tab.name=='first') this.isTimeout = 0
        if(tab.name=='second') this.isTimeout = 1
      },
    },
    components: {
      ChildTable,
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/child/register/ChildRegister.vue